import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const RemoteConfig = {
  RewardsPage: { key: 'RewardsPage', type: 'boolean', defaultValue: false },
  CardImageOptimization: { key: 'CardImageOptimization', type: 'boolean', defaultValue: false },
  ConciergePage: { key: 'ConciergePage', type: 'boolean', defaultValue: false },
  CorporateTravelPage: { key: 'CorporateTravelPage', type: 'boolean', defaultValue: false },
  LifestyleCategories: { key: 'LifestyleCategories', type: 'json', defaultValue: '[]' },
} as const;
export type RemoteConfigParam = (typeof RemoteConfig)[keyof typeof RemoteConfig];

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
  minimumFetchIntervalMillis: 60000,
  fetchTimeoutMillis: 10000,
};
remoteConfig.defaultConfig = Object.fromEntries(Object.values(RemoteConfig).map(({ key, defaultValue }) => [key, defaultValue]));

export { remoteConfig };
